import React, { useEffect } from 'react'
import { Dimmer, Grid, Loader } from 'semantic-ui-react'
import { RouteTypes } from '~/routes/constants'
import DashboardChart from '../DashboardChart'
import { FixedPricePrefixType } from '~/api/services/dashboard'
import { useTranslation } from 'react-i18next'
import SlotCard from '../SlotCard'
import { DashboardQuery } from '~/QueryHooks/DashboardQuery'

const StockExchangeDashboard:React.FC = () => {
  const { t } = useTranslation()

  const prefix = FixedPricePrefixType.StockExchange

  const {
    data: chartData,
    isLoading: isLoadingChartData
  } = DashboardQuery.getDashboardChartData(prefix)

  const {
    data: nextTradingData,
    isLoading: isLoadingNextData
  } = DashboardQuery.getDashboardNextTrading(prefix)

  const {
    data: previousTradingData,
    isLoading: isLoadingPreviousData
  } = DashboardQuery.getDashboardPreviousTrading(prefix)

  const {
    data: settings,
    isLoading: isLoadingSettings,
    refetch: refetchSettings
  } = DashboardQuery.getDashboardSettings(prefix)

  const slots = [
    {
      ...nextTradingData,
      title: t('Live / Next trading slot')
    },
    {
      ...previousTradingData,
      title: t('Last trading slot')
    }]

  useEffect(() => {
    refetchSettings()
  }, [t])

  function renderSlotCards() {
    return slots.map((tradingSlot, index) => {
      return <Grid.Column key={index}>
        <SlotCard
          tradingSlotCard={tradingSlot}
          settingsData={settings}
          url={{
            show: RouteTypes.STOCK_EXCHANGE_SHOW.replace(':id', tradingSlot?.id),
            results: RouteTypes.STOCK_EXCHANGE_RESULTS.replace(':id', tradingSlot?.id),
            offer:  RouteTypes.STOCK_EXCHANGE_OFFER_AMOUNT.replace(':id', tradingSlot?.id)
          }}
          prefix={prefix}
        />
      </Grid.Column>
    })
  }

  const isLoading = isLoadingChartData || isLoadingNextData || isLoadingPreviousData || isLoadingSettings

  return <Grid columns={2} style={{ marginTop: '1em' }}>
    <Dimmer inverted active={isLoading}>
      <Loader inverted active={isLoading}/>
    </Dimmer>
    {!isLoading && renderSlotCards()}
    {!isLoading && chartData && <Grid.Row>
      <DashboardChart
        chartData={chartData}
        link={RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', prefix)}
        prefix={prefix}
        info={t('Overview over the BLE price volumes your dairy has confirmed (including average BLE prices) for the according trading months. You can find all the details under Reporting.')}
      />
    </Grid.Row>}
  </Grid>
}
export default StockExchangeDashboard